var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiyalIconGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21099_5830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3366 18.0599C13.0689 18.6617 12.892 19.3149 12.8242 19.9998L18.4887 18.7788C18.7564 18.1771 18.9332 17.5238 19.0011 16.8389L13.3366 18.0599Z",
    fill: "#399D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4876 15.1209C18.7553 14.5192 18.9322 13.8659 19 13.181L14.5876 14.1326V12.3033L18.4875 11.4629C18.7551 10.8611 18.9321 10.2079 18.9999 9.52294L14.5874 10.4738V3.89479C13.9113 4.27975 13.3109 4.79216 12.8227 5.39658V10.8542L11.0581 11.2346V3C10.3819 3.38482 9.78149 3.89736 9.29338 4.50179V11.6148L5.34489 12.4656C5.07722 13.0673 4.90015 13.7206 4.83224 14.4055L9.29338 13.4442V15.7479L4.51239 16.7782C4.24472 17.3799 4.06779 18.0332 4 18.7181L9.00436 17.6397C9.41174 17.5538 9.76187 17.3095 9.98951 16.9734L10.9073 15.5937V15.5934C11.0026 15.4507 11.0581 15.2786 11.0581 15.0932V13.0638L12.8227 12.6835V16.3422L18.4875 15.1206L18.4876 15.1209Z",
    fill: "#399D81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21099_5830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 17,
    fill: "white",
    transform: "translate(4 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiyalIconGreen);
export default __webpack_public_path__ + "static/media/riyal-icon-green.bfd2549492de2a749203c5b401d62217.svg";
export { ForwardRef as ReactComponent };